/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateProductMovementHistoryDto } from '../models/CreateProductMovementHistoryDto';
import type { ProductHistoryDetailResponseDto } from '../models/ProductHistoryDetailResponseDto';
import type { ProductHistoryListPaginatedResponseDto } from '../models/ProductHistoryListPaginatedResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductMovementHistoryService {
  /**
   * Create a new history entry (internal use)
   * @param requestBody
   * @returns any History entry created successfully
   * @throws ApiError
   */
  public static productMovementHistoryControllerCreate(
    requestBody: CreateProductMovementHistoryDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/product-movement-history',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
      },
    });
  }
  /**
   * Get history for a catalog product (all units)
   * Returns paginated list of all history events for a product across all serialized units
   * @param productId
   * @param productCode Product code
   * @param serialNumber Serial number (product_code_unique)
   * @param eventType Event type
   * @param startDate Start date (ISO 8601)
   * @param endDate End date (ISO 8601)
   * @param userId User ID who performed the action
   * @param locationId Location ID
   * @param relatedEntityType Related entity type
   * @param relatedEntityId Related entity ID
   * @param transferCode Transfer code
   * @param orderCode Order code
   * @param recordCode Record code
   * @param search Full-text search across product name, serial number, codes, user names, notes
   * @param page Page number (default: 1)
   * @param limit Items per page (default: 50, max: 500)
   * @param sortBy Sort by field
   * @param sortOrder Sort order
   * @returns ProductHistoryListPaginatedResponseDto Product history retrieved successfully
   * @throws ApiError
   */
  public static productMovementHistoryControllerGetProductHistory(
    productId: number,
    productCode?: string,
    serialNumber?: string,
    eventType?:
      | 'INVENTORY_REGISTERED'
      | 'PRODUCT_CREATED'
      | 'PRODUCT_DELETED'
      | 'INVENTORY_RECORD_CREATED'
      | 'INVENTORY_RECORD_UPDATED'
      | 'INVENTORY_RECORD_COMPLETED'
      | 'INVENTORY_RECORD_CANCELLED'
      | 'INVENTORY_RECORD_DELETED'
      | 'TRANSFER_CREATED'
      | 'TRANSFER_COMPLETED'
      | 'TRANSFER_CANCELLED'
      | 'REQUEST_CREATED'
      | 'REQUEST_RESOLVED'
      | 'SALE_FULFILLMENT_STARTED'
      | 'SALE_FULFILLMENT_RECEIVED'
      | 'SALE_FULFILLMENT_COMPLETED'
      | 'SALE_FULFILLMENT_FAILED'
      | 'RESERVATION_CREATED'
      | 'RESERVATION_CONFIRMED'
      | 'RESERVATION_RELEASED'
      | 'RESERVATION_EXPIRED'
      | 'SALE_CREATED'
      | 'PAYMENT_RECEIVED'
      | 'PAYMENT_PROCESSED'
      | 'ORDER_REFUNDED'
      | 'ORDER_PARTIALLY_REFUNDED'
      | 'REFUND_PROCESSED'
      | 'ITEM_RETURNED'
      | 'EXCHANGE_PROCESSED'
      | 'ORDER_DELIVERY_UPDATED'
      | 'ORDER_SALE_DATE_UPDATED'
      | 'STATUS_CHANGED'
      | 'AVAILABILITY_STATUS_CHANGED'
      | 'LOCATION_CHANGED'
      | 'PRICE_CHANGED'
      | 'UNIT_ATTRIBUTE_CHANGED'
      | 'PRODUCT_CATALOG_UPDATED'
      | 'PROPERTY_ADDED'
      | 'PROPERTY_UPDATED'
      | 'PROPERTY_DELETED'
      | 'SAFETY_STOCK_UPDATED_INDIVIDUAL'
      | 'SAFETY_STOCK_UPDATED_BULK'
      | 'PHYSICAL_COUNT_FINALIZED'
      | 'ROLE_CREATED'
      | 'ROLE_UPDATED'
      | 'ROLE_DELETED'
      | 'ROLE_PERMISSIONS_UPDATED'
      | 'USER_CREATED'
      | 'USER_UPDATED'
      | 'USER_DELETED'
      | 'USER_ROLES_UPDATED'
      | 'CUSTOMER_CREATED'
      | 'CUSTOMER_UPDATED'
      | 'CUSTOMER_DELETED'
      | 'LOGIN_SUCCESS'
      | 'LOGIN_FAILED'
      | 'ACCOUNT_LOCKED'
      | 'ACCOUNT_UNLOCKED'
      | 'PASSWORD_RESET_BY_ADMIN'
      | 'PASSWORD_CHANGED'
      | 'FORCED_PASSWORD_CHANGE',
    startDate?: string,
    endDate?: string,
    userId?: string,
    locationId?: number,
    relatedEntityType?: string,
    relatedEntityId?: number,
    transferCode?: string,
    orderCode?: string,
    recordCode?: string,
    search?: string,
    page: number = 1,
    limit: number = 50,
    sortBy: 'performed_at' | 'event_type' = 'performed_at',
    sortOrder: 'ASC' | 'DESC' = 'DESC',
  ): CancelablePromise<ProductHistoryListPaginatedResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/product-movement-history/product/{productId}',
      path: {
        productId: productId,
      },
      query: {
        productCode: productCode,
        serialNumber: serialNumber,
        eventType: eventType,
        startDate: startDate,
        endDate: endDate,
        userId: userId,
        locationId: locationId,
        relatedEntityType: relatedEntityType,
        relatedEntityId: relatedEntityId,
        transferCode: transferCode,
        orderCode: orderCode,
        recordCode: recordCode,
        search: search,
        page: page,
        limit: limit,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
    });
  }
  /**
   * Get history for a specific serialized unit
   * Returns paginated list of all history events for a specific warehouse inventory product
   * @param warehouseProductId
   * @param productCode Product code
   * @param serialNumber Serial number (product_code_unique)
   * @param eventType Event type
   * @param startDate Start date (ISO 8601)
   * @param endDate End date (ISO 8601)
   * @param userId User ID who performed the action
   * @param locationId Location ID
   * @param relatedEntityType Related entity type
   * @param relatedEntityId Related entity ID
   * @param transferCode Transfer code
   * @param orderCode Order code
   * @param recordCode Record code
   * @param search Full-text search across product name, serial number, codes, user names, notes
   * @param page Page number (default: 1)
   * @param limit Items per page (default: 50, max: 500)
   * @param sortBy Sort by field
   * @param sortOrder Sort order
   * @returns ProductHistoryListPaginatedResponseDto Warehouse product history retrieved successfully
   * @throws ApiError
   */
  public static productMovementHistoryControllerGetWarehouseProductHistory(
    warehouseProductId: number,
    productCode?: string,
    serialNumber?: string,
    eventType?:
      | 'INVENTORY_REGISTERED'
      | 'PRODUCT_CREATED'
      | 'PRODUCT_DELETED'
      | 'INVENTORY_RECORD_CREATED'
      | 'INVENTORY_RECORD_UPDATED'
      | 'INVENTORY_RECORD_COMPLETED'
      | 'INVENTORY_RECORD_CANCELLED'
      | 'INVENTORY_RECORD_DELETED'
      | 'TRANSFER_CREATED'
      | 'TRANSFER_COMPLETED'
      | 'TRANSFER_CANCELLED'
      | 'REQUEST_CREATED'
      | 'REQUEST_RESOLVED'
      | 'SALE_FULFILLMENT_STARTED'
      | 'SALE_FULFILLMENT_RECEIVED'
      | 'SALE_FULFILLMENT_COMPLETED'
      | 'SALE_FULFILLMENT_FAILED'
      | 'RESERVATION_CREATED'
      | 'RESERVATION_CONFIRMED'
      | 'RESERVATION_RELEASED'
      | 'RESERVATION_EXPIRED'
      | 'SALE_CREATED'
      | 'PAYMENT_RECEIVED'
      | 'PAYMENT_PROCESSED'
      | 'ORDER_REFUNDED'
      | 'ORDER_PARTIALLY_REFUNDED'
      | 'REFUND_PROCESSED'
      | 'ITEM_RETURNED'
      | 'EXCHANGE_PROCESSED'
      | 'ORDER_DELIVERY_UPDATED'
      | 'ORDER_SALE_DATE_UPDATED'
      | 'STATUS_CHANGED'
      | 'AVAILABILITY_STATUS_CHANGED'
      | 'LOCATION_CHANGED'
      | 'PRICE_CHANGED'
      | 'UNIT_ATTRIBUTE_CHANGED'
      | 'PRODUCT_CATALOG_UPDATED'
      | 'PROPERTY_ADDED'
      | 'PROPERTY_UPDATED'
      | 'PROPERTY_DELETED'
      | 'SAFETY_STOCK_UPDATED_INDIVIDUAL'
      | 'SAFETY_STOCK_UPDATED_BULK'
      | 'PHYSICAL_COUNT_FINALIZED'
      | 'ROLE_CREATED'
      | 'ROLE_UPDATED'
      | 'ROLE_DELETED'
      | 'ROLE_PERMISSIONS_UPDATED'
      | 'USER_CREATED'
      | 'USER_UPDATED'
      | 'USER_DELETED'
      | 'USER_ROLES_UPDATED'
      | 'CUSTOMER_CREATED'
      | 'CUSTOMER_UPDATED'
      | 'CUSTOMER_DELETED'
      | 'LOGIN_SUCCESS'
      | 'LOGIN_FAILED'
      | 'ACCOUNT_LOCKED'
      | 'ACCOUNT_UNLOCKED'
      | 'PASSWORD_RESET_BY_ADMIN'
      | 'PASSWORD_CHANGED'
      | 'FORCED_PASSWORD_CHANGE',
    startDate?: string,
    endDate?: string,
    userId?: string,
    locationId?: number,
    relatedEntityType?: string,
    relatedEntityId?: number,
    transferCode?: string,
    orderCode?: string,
    recordCode?: string,
    search?: string,
    page: number = 1,
    limit: number = 50,
    sortBy: 'performed_at' | 'event_type' = 'performed_at',
    sortOrder: 'ASC' | 'DESC' = 'DESC',
  ): CancelablePromise<ProductHistoryListPaginatedResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/product-movement-history/warehouse-product/{warehouseProductId}',
      path: {
        warehouseProductId: warehouseProductId,
      },
      query: {
        productCode: productCode,
        serialNumber: serialNumber,
        eventType: eventType,
        startDate: startDate,
        endDate: endDate,
        userId: userId,
        locationId: locationId,
        relatedEntityType: relatedEntityType,
        relatedEntityId: relatedEntityId,
        transferCode: transferCode,
        orderCode: orderCode,
        recordCode: recordCode,
        search: search,
        page: page,
        limit: limit,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
    });
  }
  /**
   * Advanced search with filters
   * Search history records with multiple filters and full-text search
   * @param productId Product ID (catalog level)
   * @param warehouseProductId Warehouse inventory product ID (serialized unit)
   * @param productCode Product code
   * @param serialNumber Serial number (product_code_unique)
   * @param eventType Event type
   * @param startDate Start date (ISO 8601)
   * @param endDate End date (ISO 8601)
   * @param userId User ID who performed the action
   * @param locationId Location ID
   * @param relatedEntityType Related entity type
   * @param relatedEntityId Related entity ID
   * @param transferCode Transfer code
   * @param orderCode Order code
   * @param recordCode Record code
   * @param search Full-text search across product name, serial number, codes, user names, notes
   * @param page Page number (default: 1)
   * @param limit Items per page (default: 50, max: 500)
   * @param sortBy Sort by field
   * @param sortOrder Sort order
   * @returns ProductHistoryListPaginatedResponseDto Search results retrieved successfully
   * @throws ApiError
   */
  public static productMovementHistoryControllerSearch(
    productId?: number,
    warehouseProductId?: number,
    productCode?: string,
    serialNumber?: string,
    eventType?:
      | 'INVENTORY_REGISTERED'
      | 'PRODUCT_CREATED'
      | 'PRODUCT_DELETED'
      | 'INVENTORY_RECORD_CREATED'
      | 'INVENTORY_RECORD_UPDATED'
      | 'INVENTORY_RECORD_COMPLETED'
      | 'INVENTORY_RECORD_CANCELLED'
      | 'INVENTORY_RECORD_DELETED'
      | 'TRANSFER_CREATED'
      | 'TRANSFER_COMPLETED'
      | 'TRANSFER_CANCELLED'
      | 'REQUEST_CREATED'
      | 'REQUEST_RESOLVED'
      | 'SALE_FULFILLMENT_STARTED'
      | 'SALE_FULFILLMENT_RECEIVED'
      | 'SALE_FULFILLMENT_COMPLETED'
      | 'SALE_FULFILLMENT_FAILED'
      | 'RESERVATION_CREATED'
      | 'RESERVATION_CONFIRMED'
      | 'RESERVATION_RELEASED'
      | 'RESERVATION_EXPIRED'
      | 'SALE_CREATED'
      | 'PAYMENT_RECEIVED'
      | 'PAYMENT_PROCESSED'
      | 'ORDER_REFUNDED'
      | 'ORDER_PARTIALLY_REFUNDED'
      | 'REFUND_PROCESSED'
      | 'ITEM_RETURNED'
      | 'EXCHANGE_PROCESSED'
      | 'ORDER_DELIVERY_UPDATED'
      | 'ORDER_SALE_DATE_UPDATED'
      | 'STATUS_CHANGED'
      | 'AVAILABILITY_STATUS_CHANGED'
      | 'LOCATION_CHANGED'
      | 'PRICE_CHANGED'
      | 'UNIT_ATTRIBUTE_CHANGED'
      | 'PRODUCT_CATALOG_UPDATED'
      | 'PROPERTY_ADDED'
      | 'PROPERTY_UPDATED'
      | 'PROPERTY_DELETED'
      | 'SAFETY_STOCK_UPDATED_INDIVIDUAL'
      | 'SAFETY_STOCK_UPDATED_BULK'
      | 'PHYSICAL_COUNT_FINALIZED'
      | 'ROLE_CREATED'
      | 'ROLE_UPDATED'
      | 'ROLE_DELETED'
      | 'ROLE_PERMISSIONS_UPDATED'
      | 'USER_CREATED'
      | 'USER_UPDATED'
      | 'USER_DELETED'
      | 'USER_ROLES_UPDATED'
      | 'CUSTOMER_CREATED'
      | 'CUSTOMER_UPDATED'
      | 'CUSTOMER_DELETED'
      | 'LOGIN_SUCCESS'
      | 'LOGIN_FAILED'
      | 'ACCOUNT_LOCKED'
      | 'ACCOUNT_UNLOCKED'
      | 'PASSWORD_RESET_BY_ADMIN'
      | 'PASSWORD_CHANGED'
      | 'FORCED_PASSWORD_CHANGE',
    startDate?: string,
    endDate?: string,
    userId?: string,
    locationId?: number,
    relatedEntityType?: string,
    relatedEntityId?: number,
    transferCode?: string,
    orderCode?: string,
    recordCode?: string,
    search?: string,
    page: number = 1,
    limit: number = 50,
    sortBy: 'performed_at' | 'event_type' = 'performed_at',
    sortOrder: 'ASC' | 'DESC' = 'DESC',
  ): CancelablePromise<ProductHistoryListPaginatedResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/product-movement-history/search',
      query: {
        productId: productId,
        warehouseProductId: warehouseProductId,
        productCode: productCode,
        serialNumber: serialNumber,
        eventType: eventType,
        startDate: startDate,
        endDate: endDate,
        userId: userId,
        locationId: locationId,
        relatedEntityType: relatedEntityType,
        relatedEntityId: relatedEntityId,
        transferCode: transferCode,
        orderCode: orderCode,
        recordCode: recordCode,
        search: search,
        page: page,
        limit: limit,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
    });
  }
  /**
   * Get detailed view of a single history record
   * Returns full details including changed fields, previous/new values, and all related data. Menu-only: same permission as the list.
   * @param id
   * @returns ProductHistoryDetailResponseDto History detail retrieved successfully
   * @throws ApiError
   */
  public static productMovementHistoryControllerGetDetail(
    id: number,
  ): CancelablePromise<ProductHistoryDetailResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/product-movement-history/{id}',
      path: {
        id: id,
      },
      errors: {
        404: `History record not found`,
      },
    });
  }
}
